import { Fragment, useEffect } from "react";
import { usePathname } from "next/navigation";

import { isDatadog } from "../../utils/isDatadog";
import emitEvent from "./emitEvent";

type Props = {
  children: React.ReactNode;
};

export function TrackRouting({ children }: Props) {
  const pathname = usePathname();

  const path = pathname || "";

  useEffect(() => {
    // Only track on the client side
    // and do not track the pre-hydrated path that doesn't include the
    // real params (i.e. [accountId])
    if (!(path.includes("[") && path.includes("]")) && !isDatadog()) {
      // Emit PageViewEvent for actual navigation events
      // Other PageViewEvent fields are set automatically by events-toolkit-browser and the v4 Events API
      // https://engineering.zapier.com/guides/event-streaming/tracking-events/
      emitEvent("web_analytics.tracking.page_view.PageViewEvent");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  return <Fragment>{children}</Fragment>;
}
